const tooManyRequestsMessage =
  "تعداد درخواست‌ها بیش از حد مجاز است. لطفاً کمی بعد دوباره تلاش کنید.";
const defaultLoginErrorMessage = "خطایی رخ داده، دوباره تلاش کنید.";

type ErrorRecord = Record<string, unknown>;

const asRecord = (value: unknown): ErrorRecord | undefined =>
  typeof value === "object" && value !== null
    ? (value as ErrorRecord)
    : undefined;

export const getLoginErrorMessage = (error: unknown): string => {
  const errorRecord = asRecord(error);
  const response = asRecord(errorRecord?.response);
  const responseData = asRecord(response?.data);
  const status = errorRecord?.status ?? response?.status;

  if (status === 429) return tooManyRequestsMessage;

  const message =
    errorRecord?.message ??
    response?.message ??
    responseData?.message ??
    responseData?.error;

  return typeof message === "string" && message
    ? message
    : defaultLoginErrorMessage;
};
